import CommonInfo from "../Common/Info"
import IPAddress from "./IPAddress";
import UserDetails from "../Common/Schema/UserDetails";
export default class Info {
    public static prettifyIfPossible(value: any) : any{
        // return CommonInfo.prettifyIfPossible(value);
        if (!value)
            return null;
        const allKeys: string[] = Object.getOwnPropertyNames(value)
        const data: any = {};
        allKeys.forEach((key: string) => {
            data[key] = value[key];
        });
        return JSON.stringify(data, null, 1);
    }
    public static getBrowserSize(): {width: number, height: number}
    {
        const size = {width: 0, height: 0};
        size.width = window.innerWidth;
        size.height = window.innerHeight;
        return size;
    }

    static isEmailValid(email: string): boolean{
        return CommonInfo.isEmailValid(email);
    }

    static isLinkValid(link: string): boolean{
        return CommonInfo.isWebsiteLinkValid(link);
    }

    private static getDeviceType(){
        const ua = navigator.userAgent;
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
            return "tablet";
        }
        else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
            return "mobile";
        }
        return "desktop";
    }

    public static getUserDetails(headers:  Readonly<Record<string, string>>): UserDetails{
        let ipAddress: string | null = IPAddress.get(headers);
        const referrer: string | undefined = headers?.referer;
        const allDeviceDetails = Info.getBrowserDetails();
        const device: string = allDeviceDetails["Browser Name"];
        const os: string = allDeviceDetails["OS Name"];
        const deviceType: string = this.getDeviceType();
        //@ts-ignore
        if (process.dev)
            ipAddress = "102.90.101.107";
        return {
            ipAddress,
            referrer,
            device,
            deviceType,
            os
        };
    }

    public static getBrowserDetails(): {"Browser Name": string, "Full Version": string, "Major Version": number, AppName: string, UserAgent: string, "OS Name": string}{
        const nVer = navigator.appVersion;
        const nAgt = navigator.userAgent;
        let browserName = navigator.appName;
        let fullVersion = "" + parseFloat(navigator.appVersion);
        let majorVersion = parseInt(navigator.appVersion, 10);
        let nameOffset, verOffset, ix;

        // In Opera, the true version is after "Opera" or after "Version"
        if ((verOffset = nAgt.indexOf("Opera")) != -1) {
            browserName = "Opera";
            fullVersion = nAgt.substring(verOffset + 6);
            if ((verOffset = nAgt.indexOf("Version")) != -1)
                fullVersion = nAgt.substring(verOffset + 8);
        }
        // In MSIE, the true version is after "MSIE" in userAgent
        else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
            browserName = "Microsoft Internet Explorer";
            fullVersion = nAgt.substring(verOffset + 5);
        }
        // In Chrome, the true version is after "Chrome"
        else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
            browserName = "Chrome";
            fullVersion = nAgt.substring(verOffset + 7);
        }
        // In Safari, the true version is after "Safari" or after "Version"
        else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
            browserName = "Safari";
            fullVersion = nAgt.substring(verOffset + 7);
            if ((verOffset = nAgt.indexOf("Version")) != -1)
                fullVersion = nAgt.substring(verOffset + 8);
        }
        // In Firefox, the true version is after "Firefox"
        else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
            browserName = "Firefox";
            fullVersion = nAgt.substring(verOffset + 8);
        }
        // In most other browsers, "name/version" is at the end of userAgent
        else if (
            (nameOffset = nAgt.lastIndexOf(" ") + 1) <
            (verOffset = nAgt.lastIndexOf("/"))
        ) {
            browserName = nAgt.substring(nameOffset, verOffset);
            fullVersion = nAgt.substring(verOffset + 1);
            if (browserName.toLowerCase() == browserName.toUpperCase()) {
                browserName = navigator.appName;
            }
        }
        // trim the fullVersion string at semicolon/space if present
        if ((ix = fullVersion.indexOf(";")) != -1)
            fullVersion = fullVersion.substring(0, ix);
        if ((ix = fullVersion.indexOf(" ")) != -1)
            fullVersion = fullVersion.substring(0, ix);

        majorVersion = parseInt("" + fullVersion, 10);
        if (isNaN(majorVersion)) {
            fullVersion = "" + parseFloat(navigator.appVersion);
            majorVersion = parseInt(navigator.appVersion, 10);
        }

        let OSName = "Unknown OS";
        if (navigator.appVersion.indexOf("Win") != -1) OSName = "Windows";
        if (navigator.appVersion.indexOf("Mac") != -1) OSName = "MacOS";
        if (navigator.appVersion.indexOf("X11") != -1) OSName = "UNIX";
        if (navigator.appVersion.indexOf("Linux") != -1) OSName = "Linux";

        return {
            "Browser Name": browserName,
            "Full Version": fullVersion,
            "Major Version": majorVersion,
            AppName: navigator.appName,
            UserAgent: navigator.userAgent,
            "OS Name": OSName,
        };
    }
}


